import React, { Component } from 'react';
import { StyleSheet } from 'react-native';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';
// import StatusView from '@vfgroup-oneplatform/foundation/Components/StatusView';

class SuccessModal extends Component {
  getLottieProps = () => ({
    type: 'tick',
    autoPlay: true,
    loop: false,
    lottieViewStyle: { width: 140, height: 140 },
  });

  getPrimaryButtonProps = () => {
    if (_.isFunction(this.props.onPrimaryPress)) {
      return {
        title: 'privacy_settings_quick_action_primary_button_text',
        onPress: this.props.onPrimaryPress,
      };
    }
  };

  getSecondaryButtonProps = () => {
    if (_.isFunction(this.props.onSecondaryPress)) {
      return {
        title: 'privacy_settings_quick_action_secondary_button_text',
        onPress: this.props.onSecondaryPress,
      };
    }
  };

  render() {
    return (
      <QuickActionMenu
        isVisible={this.props.isVisible}
        type="secondary"
        withCloseButton={false}
        title="subtray_privacy_title"
        headerStyle={styles.headerStyle}
        toggleModal={this.props.onSecondaryPress || (() => null)}
      >
        {/* <StatusView
          lottieProps={this.getLottieProps()}
          title="privacy_settings_quick_action_title"
          description="privacy_settings_quick_action_description"
          textStyles={{ description: { marginBottom: 51 } }}
          primaryButtonProps={this.getPrimaryButtonProps()}
          secondaryButtonProps={this.getSecondaryButtonProps()}
        /> */}
      </QuickActionMenu>
    );
  }
}

const styles = StyleSheet.create({ headerStyle: { marginHorizontal: 0 } });

SuccessModal.propTypes = {
  isVisible: PropTypes.bool,
  onPrimaryPress: PropTypes.func,
  onSecondaryPress: PropTypes.func,
};

export default SuccessModal;
